import React, { useCallback, useState } from "react";
import { StyleSheet, Pressable, Image, View } from "react-native";
import { Caret, Download, Xv2 } from "../../../../assets";
import { createUUID } from "../../../../utils/functions";

type MessageThreadPatientInfoProps = {
  image_urls: string[];
  image_initial_index: number;
  handleModalClose: () => void;
};

const MessageThreadPatientInfo: React.FC<MessageThreadPatientInfoProps> = ({
  image_urls,
  image_initial_index,
  handleModalClose,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(image_initial_index);

  const handleNextImage = () => {
    setSelectedIndex((prev) => Math.min(prev + 1, image_urls.length - 1));
  };

  const handlePrevImage = () => {
    setSelectedIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleDownload = useCallback(async () => {
    try {
      const response = await fetch(image_urls[selectedIndex]);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const urlObject = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = urlObject;
      link.download = `${createUUID()}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(urlObject);
    } catch (error) {
      console.error("Download failed:", error);
    }
  }, [selectedIndex, image_urls]);

  return (
    <View style={styles.modalContainer}>
      {selectedIndex > 0 && (
        <Pressable
          onPress={handlePrevImage}
          style={[styles.navButton, styles.leftButton]}
        >
          <Caret color="white" direction="left" />
        </Pressable>
      )}

      {selectedIndex < image_urls.length - 1 && (
        <Pressable
          onPress={handleNextImage}
          style={[styles.navButton, styles.rightButton]}
        >
          <Caret color="white" direction="right" />
        </Pressable>
      )}

      <Image
        source={{ uri: image_urls[selectedIndex] }}
        style={styles.modalImage}
      />

      <Pressable onPress={handleModalClose} style={styles.closeButton}>
        <Xv2 color="#fff" />
      </Pressable>

      <Pressable onPress={handleDownload} style={styles.downloadButton}>
        <Download />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.8)",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  modalImage: {
    width: "90%",
    height: "70%",
    resizeMode: "contain",
    borderRadius: 10,
  },
  navButton: {
    position: "absolute",
    top: "50%",
    transform: [{ translateY: -25 }],
    padding: 10,
  },
  leftButton: {
    left: 0,
  },
  rightButton: {
    right: 0,
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  downloadButton: {
    position: "absolute",
    bottom: 15,
    right: 15,
  },
});

export default MessageThreadPatientInfo;
